import React, {ReactNode, useRef} from 'react';

//Material UI
import {Container, Box, useMediaQuery, useTheme} from '@mui/material';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles({
    root: {
        background: '#f5f5f5',
    },
});

interface Props {
    children?: ReactNode;
    // any props that come into the component
}

export const Wrapper: React.FC<Props> = ({children}) => {
    const constraintsRef = useRef<HTMLInputElement>(null);

    const classes = useStyles();
    const {breakpoints} = useTheme();
    const isTablet = useMediaQuery(breakpoints.down('md'));

    return (
        <main className={classes.root}>
            <Container maxWidth={'lg'}
                       ref={constraintsRef}
                       style={{paddingBottom: '100px'}}
                      >
                <Box
                    sx={{flexGrow: 1}}
                    style={{
                        marginTop: isTablet ? 120 : 90,
                        minHeight:  '73vh',
                        position: 'relative',
                    }}
                >
                    {children}
                </Box>
            </Container>

        </main>
    );
};
